/**
 * Which open dialog is on top, so Escape closes only that one.
 *
 * Every dialog used to attach its own document-level Escape listener. With a
 * dialog open over another — "Void and revise?" over the quote editor — one
 * key press closed the editor underneath while the confirmation stayed on
 * screen, and confirming then ran against an editor that no longer existed.
 *
 * A dialog registers when it opens and releases when it closes; its Escape
 * handler acts only while `isTop()` is true. Order is opening order, which is
 * stacking order: a dialog opened later is drawn above the ones before it.
 */
export interface DialogHandle {
    isTop: () => boolean;
    release: () => void;
}

const stack: symbol[] = [];

export function registerDialog(): DialogHandle {
    const id = Symbol('dialog');
    stack.push(id);
    return {
        isTop: () => stack[stack.length - 1] === id,
        release: () => {
            const i = stack.lastIndexOf(id);
            if (i >= 0) stack.splice(i, 1);
        },
    };
}
